import type {
  GetListResponseOfRegionSimpleResponse,
  GetListResponseOfSelectOption,
  GetRegionListRequestV2,
  RegionRequest,
  RegionResponse,
} from 'src/api/ProactApiClient';
import {regionApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const regionApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getRegionListV2: builder.query<
      GetListResponseOfRegionSimpleResponse,
      GetRegionListRequestV2
    >({
      queryFn: clientQuery(params => regionApiClient.listV2(params)),
      providesTags: ['Regions'],
    }),
    getRegionSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetRegionListRequestV2
    >({
      queryFn: clientQuery(params => regionApiClient.listSelectOptions(params)),
      providesTags: ['Regions'],
    }),
    getRegion: builder.query<RegionResponse, number>({
      queryFn: clientQuery(id => regionApiClient.get(id)),
      providesTags: ['Regions'],
    }),
    // Deleting a region clears it on every project referencing it, so region
    // mutations invalidate the project cache too.
    createRegion: builder.mutation<RegionResponse, RegionRequest>({
      queryFn: clientQuery(request => regionApiClient.create(request)),
      invalidatesTags: ['Regions', 'Projects'],
    }),
    updateRegion: builder.mutation<RegionResponse, RegionRequest>({
      queryFn: clientQuery(request => regionApiClient.update(request)),
      invalidatesTags: ['Regions', 'Projects'],
    }),
    deleteRegion: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => regionApiClient.delete(id)),
      invalidatesTags: ['Regions', 'Projects'],
    }),
  }),
});

export const {
  useGetRegionListV2Query,
  useGetRegionSelectOptionsQuery,
  useGetRegionQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useDeleteRegionMutation,
} = regionApi;
